import { IReferenceScore } from '../common/models/reference/IReferenceScore';
import api from '../common/helpers/apiHelper';
import { key, getCode } from '../common/helpers/common';
import { mapSortToSortReq, mapFilterToFilterReq } from '../common/helpers/filterHelper';
import { IContactFilter } from '../common/models/filter/IContactFilter';
import { IReferenceWithQuestions } from '../common/models/reference/IReferenceWithQuestions';
import { IReferenceSurvey } from '../common/models/reference/IReferenceSurvey';
import { IResendSurvey } from '../common/models/reference/IResendSurvey';
import { IReferenceCandidateFormMessage } from '../common/models/reference/IReferenceCandidateFormMessage';
import { IWorkspace } from '../common/models/workspace/IWorkspace';
import { IReferencesStatus } from '../common/models/reference/IReferenceStatus';
import { IQuestionForReference } from '../common/models/question/IQuestionForReference';

export const getByCandidateId = ({ id, ...rest }: IContactFilter) => api.get<IReferenceScore[]>(
  `/api/candidates/${id}/references`,
  { sort: mapSortToSortReq(rest.sort), filter: mapFilterToFilterReq(rest.filter) }
);

export const getRefForManualInput = (id: string) => (
  api.get<IReferenceWithQuestions>(`/api/references/${id}/manual-input`)
);

export const checkKey = () => api.get<IWorkspace>('/public-api/reference-key/valid', { key });

export const checkCode = (code: string) => api.get<IReferenceWithQuestions>(
  '/public-api/reference-code/valid', { code, key }
);

export const getReferenceWithQuestions = () => api.get<IReferenceWithQuestions & { workspace: IWorkspace }>(
  '/reference-api/survey', { key, code: getCode() }
);

export const startSurvey = () => api.put(`/reference-api/start?key=${key}&code=${getCode()}`);

export const finishSurvey = () => api.put(`/reference-api/finish?key=${key}&code=${getCode()}`);

export const startSurveyManually = (id: string) => api.put(`/api/references/${id}/start`);

export const finishSurveyManually = (id: string) => api.put(`/api/references/${id}/finish`);

export const confirmReference = (reference: IReferenceSurvey) => api.put<IQuestionForReference[]>(
  `/reference-api/confirm?key=${key}&code=${getCode()}`, reference
);

export const confirmRefManualInput = (reference: IReferenceSurvey) => api.put<IQuestionForReference[]>(
  '/api/references/confirm', reference
);

export const saveReferences = (refs: IReferenceCandidateFormMessage) => (
  api.post(`/candidate-api/references?key=${key}&code=${getCode()}`, refs)
);

export const resendSurvey = (ref: IResendSurvey) => (
  api.post(`/candidate-api/resend?key=${key}&code=${getCode()}`, ref)
);

export const declineSurvey = (reason: string) => (
  api.put(`/reference-api/decline?key=${key}&code=${getCode()}`, { reason })
);

export const updateRefStatus = (data: IReferencesStatus) => api.put('/api/references/status', data);
